module.exports = __webpack_public_path__ + "static/media/feed.02e0fa3d.svg";